module.exports = __webpack_public_path__ + "static/img/smartphone.44dd48d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/smartphone.svg
// module id = 6OWV
// module chunks = 1